import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function CTASection() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden"
        >
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/7d116e9358317b93cbb6b5026bb74820.jpg"
              alt="Yangın güvenlik çözümleri"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/60 to-black/40"></div>
          </div>

          <div className="relative z-10 p-12 lg:p-20 flex flex-col lg:flex-row items-center justify-between gap-10">
            <div className="max-w-xl">
              <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
                Güvenliğiniz İçin <span className="text-red-400">Harekete Geçin</span>
              </h2>
              <p className="text-white/70 leading-relaxed">
                Ücretsiz keşif ve fiyat teklifi için hemen iletişime geçin. Uzman ekibimiz mekanınıza en uygun yangın güvenlik çözümünü tasarlasın.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/hizmetler"
                className="px-8 py-4 bg-red-600 text-white font-semibold rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-file-list-3-line"></i>
                Teklif Alın
              </Link>
              <a
                href="tel:+903126660636"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-semibold rounded-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-phone-line"></i>
                0312 666 06 36
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
